import { FC, MouseEvent } from "react";
import {
  GridActionsCellItem,
  useGridApiContext,
  GridApi,
} from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { Close as CancelIcon } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { ActionButtonProps } from "./AssociateGroupsTable";

export const CancelButton: FC<ActionButtonProps> = ({ id }) => {
  const apiRef = useGridApiContext<GridApi>();
  const { t } = useTranslation();
  const label = t("cancel");

  const onClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    apiRef.current.stopRowEditMode({ id, ignoreModifications: true });
  };

  return (
    <GridActionsCellItem
      icon={
        <Tooltip title={label}>
          <CancelIcon />
        </Tooltip>
      }
      label={label}
      onClick={onClick}
    />
  );
};
